import { render, staticRenderFns } from "./marketingBannersTable.vue?vue&type=template&id=905b0cbc&"
import script from "./marketingBannersTable.vue?vue&type=script&lang=js&"
export * from "./marketingBannersTable.vue?vue&type=script&lang=js&"
import style0 from "./marketingBannersTable.vue?vue&type=style&index=0&id=905b0cbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports